import './NTFD.scss';
import {PageManager} from '@mvps-genesis/bootstrap';

export default class NTFD extends PageManager {

	constructor (pageContext) {

		super(pageContext);

	}

	onReady () {

		// Runs after `DOMContentLoaded` event

	}
}
